'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './ReviewsSlider.module.scss';
import { ReviewsSliderProps } from '@/types/reviewsSlider.types';

const ReviewsSlider = ({ slides }: ReviewsSliderProps) => {
  return (
    <section className="container">
      <div className={styles.sliderWrapper}>
        <style jsx global>{`
          .swiper-pagination {
            position: absolute;
            bottom: -40px !important;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .swiper-pagination-bullet {
            width: 19px;
            height: 4px;
            background: #d9d9d9;
            opacity: 1;
            margin: 0 6px;
            cursor: pointer;
            border-radius: 6px;
          }
          .swiper-pagination-bullet-active {
            background: #4d535f;
            width: 48px;
            height: 4px;
          }
        `}</style>
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
          spaceBetween={30}
          slidesPerView={1.3}
          breakpoints={{
            320: {
              slidesPerView: 1.1,
              spaceBetween: 16,
            },
            576: {
              slidesPerView: 1.1,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 1.2,
              spaceBetween: 24,
            },
            992: {
              slidesPerView: 1.2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 1.3,
              spaceBetween: 40,
            },
          }}
          className={styles.swiper}
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className={styles.slide}>
                <div className={styles.imageWrapper}>
                  <Image
                    src={slide.backgroundImage}
                    alt="Private jet interior"
                    width={1440}
                    height={400}
                    sizes="(max-width: 768px) 90vw, 70vw"
                    className={styles.image}
                    loading="lazy"
                  />
                </div>
                <div className={styles.content}>
                  <p className={styles.text}>{slide.text}</p>
                  <div className={styles.author}>
                    <div className={styles.authorInfo}>
                      <p className={styles.name}>{slide.author.name}</p>
                      <p className={styles.position}>{slide.author.position}</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ReviewsSlider;
